'use client';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import makeEventProps from 'make-event-props';
import makeCancellable from 'make-cancellable-promise';
import clsx from 'clsx';
import invariant from 'tiny-invariant';
import warning from 'warning';
import { dequal } from 'dequal';
import * as pdfjs from 'pdfjs-dist';
import DocumentContext from './DocumentContext.js';
import Message from './Message.js';
import LinkService from './LinkService.js';
import PasswordResponses from './PasswordResponses.js';
import { cancelRunningTask, dataURItoByteString, displayCORSWarning, isArrayBuffer, isBlob, isBrowser, isDataURI, loadFromFile } from './shared/utils.js';
import useResolver from './shared/hooks/useResolver.js';
var PDFDataRangeTransport = pdfjs.PDFDataRangeTransport;

var defaultOnPassword = function defaultOnPassword(callback, reason) {
  switch (reason) {
    case PasswordResponses.NEED_PASSWORD:
      {
        // eslint-disable-next-line no-alert
        var password = prompt('Enter the password to open this PDF file.');
        callback(password);
        break;
      }

    case PasswordResponses.INCORRECT_PASSWORD:
      {
        // eslint-disable-next-line no-alert
        var _password = prompt('Invalid password. Please try again.');

        callback(_password);
        break;
      }

    default:
  }
};

function isParameterObject(file) {
  return _typeof(file) === 'object' && file !== null && ('data' in file || 'range' in file || 'url' in file);
}
/**
 * Loads a document passed using `file` prop.
 */


var Document = forwardRef(function Document(_a, ref) {
  var _this = this;

  var children = _a.children,
      className = _a.className,
      _a$error = _a.error,
      error = _a$error === void 0 ? 'Failed to load PDF file.' : _a$error,
      externalLinkRel = _a.externalLinkRel,
      externalLinkTarget = _a.externalLinkTarget,
      file = _a.file,
      inputRef = _a.inputRef,
      imageResourcesPath = _a.imageResourcesPath,
      _a$loading = _a.loading,
      loading = _a$loading === void 0 ? 'Loading PDF…' : _a$loading,
      _a$noData = _a.noData,
      noData = _a$noData === void 0 ? 'No PDF file specified.' : _a$noData,
      onItemClick = _a.onItemClick,
      onLoadErrorProps = _a.onLoadError,
      onLoadProgress = _a.onLoadProgress,
      onLoadSuccessProps = _a.onLoadSuccess,
      _a$onPassword = _a.onPassword,
      onPassword = _a$onPassword === void 0 ? defaultOnPassword : _a$onPassword,
      onSourceErrorProps = _a.onSourceError,
      onSourceSuccessProps = _a.onSourceSuccess,
      options = _a.options,
      renderMode = _a.renderMode,
      rotate = _a.rotate,
      otherProps = __rest(_a, ["children", "className", "error", "externalLinkRel", "externalLinkTarget", "file", "inputRef", "imageResourcesPath", "loading", "noData", "onItemClick", "onLoadError", "onLoadProgress", "onLoadSuccess", "onPassword", "onSourceError", "onSourceSuccess", "options", "renderMode", "rotate"]);

  var _useResolver = useResolver(),
      _useResolver2 = _slicedToArray(_useResolver, 2),
      sourceState = _useResolver2[0],
      sourceDispatch = _useResolver2[1];

  var source = sourceState.value,
      sourceError = sourceState.error;

  var _useResolver3 = useResolver(),
      _useResolver4 = _slicedToArray(_useResolver3, 2),
      pdfState = _useResolver4[0],
      pdfDispatch = _useResolver4[1];

  var pdf = pdfState.value,
      pdfError = pdfState.error;
  var linkService = useRef(new LinkService());
  var pages = useRef([]);
  var prevFile = useRef(undefined);
  var prevOptions = useRef(undefined);

  if (file && file !== prevFile.current && isParameterObject(file)) {
    warning(!dequal(file, prevFile.current), "File prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to \"file\" prop.");
    prevFile.current = file;
  } // Detect non-memoized changes in options prop


  if (options && options !== prevOptions.current) {
    warning(!dequal(options, prevOptions.current), "Options prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to \"options\" prop.");
    prevOptions.current = options;
  }

  var viewer = useRef({
    // Handling jumping to internal links target
    scrollPageIntoView: function scrollPageIntoView(args) {
      var dest = args.dest,
          pageNumber = args.pageNumber,
          _args$pageIndex = args.pageIndex,
          pageIndex = _args$pageIndex === void 0 ? pageNumber - 1 : _args$pageIndex; // First, check if custom handling of onItemClick was provided

      if (onItemClick) {
        onItemClick({
          dest: dest,
          pageIndex: pageIndex,
          pageNumber: pageNumber
        });
        return;
      } // If not, try to look for target page within the <Document>.


      var page = pages.current[pageIndex];

      if (page) {
        // Scroll to the page automatically
        page.scrollIntoView();
        return;
      }

      warning(false, "An internal link leading to page ".concat(pageNumber, " was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>."));
    }
  });
  useImperativeHandle(ref, function () {
    return {
      linkService: linkService,
      pages: pages,
      viewer: viewer
    };
  }, []);
  /**
   * Called when a document source is resolved correctly
   */

  function onSourceSuccess() {
    if (onSourceSuccessProps) {
      onSourceSuccessProps();
    }
  }
  /**
   * Called when a document source failed to be resolved correctly
   */


  function onSourceError() {
    if (!sourceError) {
      // Impossible, but TypeScript doesn't know that
      return;
    }

    warning(false, sourceError.toString());

    if (onSourceErrorProps) {
      onSourceErrorProps(sourceError);
    }
  }

  function resetSource() {
    sourceDispatch({
      type: 'RESET'
    });
  }

  useEffect(resetSource, [file, sourceDispatch]);
  var findDocumentSource = useCallback(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fileByteString, data, url, otherParams, _fileByteString;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (file) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", null);

            case 2:
              if (!(typeof file === 'string')) {
                _context.next = 8;
                break;
              }

              if (!isDataURI(file)) {
                _context.next = 6;
                break;
              }

              fileByteString = dataURItoByteString(file);
              return _context.abrupt("return", {
                data: fileByteString
              });

            case 6:
              displayCORSWarning();
              return _context.abrupt("return", {
                url: file
              });

            case 8:
              if (!(file instanceof PDFDataRangeTransport)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", {
                range: file
              });

            case 10:
              if (!isArrayBuffer(file)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", {
                data: file
              });

            case 12:
              if (!isBrowser) {
                _context.next = 18;
                break;
              }

              if (!isBlob(file)) {
                _context.next = 18;
                break;
              }

              _context.next = 16;
              return loadFromFile(file);

            case 16:
              data = _context.sent;
              return _context.abrupt("return", {
                data: data
              });

            case 18:
              // At this point, file must be an object
              invariant(_typeof(file) === 'object', 'Invalid parameter in file, need either Uint8Array, string or a parameter object');
              invariant(isParameterObject(file), 'Invalid parameter object: need either .data, .range or .url'); // File .url is a string

              if (!('url' in file && typeof file.url === 'string')) {
                _context.next = 26;
                break;
              }

              if (!isDataURI(file.url)) {
                _context.next = 25;
                break;
              }

              url = file.url, otherParams = __rest(file, ["url"]);
              _fileByteString = dataURItoByteString(url);
              return _context.abrupt("return", Object.assign({
                data: _fileByteString
              }, otherParams));

            case 25:
              displayCORSWarning();

            case 26:
              return _context.abrupt("return", file);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, [file]);
  useEffect(function () {
    var cancellable = makeCancellable(findDocumentSource());
    cancellable.promise.then(function (nextSource) {
      sourceDispatch({
        type: 'RESOLVE',
        value: nextSource
      });
    }).catch(function (error) {
      sourceDispatch({
        type: 'REJECT',
        error: error
      });
    });
    return function () {
      cancelRunningTask(cancellable);
    };
  }, [findDocumentSource, sourceDispatch]);
  useEffect(function () {
    if (typeof source === 'undefined') {
      return;
    }

    if (source === false) {
      onSourceError();
      return;
    }

    onSourceSuccess();
  }, // Ommitted callbacks so they are not called every time they change
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [source]);
  /**
   * Called when a document is read successfully
   */

  function onLoadSuccess() {
    if (!pdf) {
      // Impossible, but TypeScript doesn't know that
      return;
    }

    if (onLoadSuccessProps) {
      onLoadSuccessProps(pdf);
    }

    pages.current = new Array(pdf.numPages);
    linkService.current.setDocument(pdf);
  }
  /**
   * Called when a document failed to read successfully
   */


  function onLoadError() {
    if (!pdfError) {
      // Impossible, but TypeScript doesn't know that
      return;
    }

    warning(false, pdfError.toString());

    if (onLoadErrorProps) {
      onLoadErrorProps(pdfError);
    }
  }

  function resetDocument() {
    pdfDispatch({
      type: 'RESET'
    });
  }

  useEffect(resetDocument, [pdfDispatch, source]);

  function loadDocument() {
    if (!source) {
      return;
    }

    var documentInitParams = Object.assign(Object.assign({}, source), options);
    var destroyable = pdfjs.getDocument(documentInitParams);

    if (onLoadProgress) {
      destroyable.onProgress = onLoadProgress;
    }

    if (onPassword) {
      destroyable.onPassword = onPassword;
    }

    var loadingTask = destroyable;
    loadingTask.promise.then(function (nextPdf) {
      pdfDispatch({
        type: 'RESOLVE',
        value: nextPdf
      });
    }).catch(function (error) {
      if (loadingTask.destroyed) {
        return;
      }

      pdfDispatch({
        type: 'REJECT',
        error: error
      });
    });
    return function () {
      loadingTask.destroy();
    };
  }

  useEffect(loadDocument, // Ommitted callbacks so they are not called every time they change
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [options, pdfDispatch, source]);
  useEffect(function () {
    if (typeof pdf === 'undefined') {
      return;
    }

    if (pdf === false) {
      onLoadError();
      return;
    }

    onLoadSuccess();
  }, // Ommitted callbacks so they are not called every time they change
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [pdf]);

  function setupLinkService() {
    linkService.current.setViewer(viewer.current);
    linkService.current.setExternalLinkRel(externalLinkRel);
    linkService.current.setExternalLinkTarget(externalLinkTarget);
  }

  useEffect(setupLinkService, [externalLinkRel, externalLinkTarget]);

  function registerPage(pageIndex, ref) {
    pages.current[pageIndex] = ref;
  }

  function unregisterPage(pageIndex) {
    delete pages.current[pageIndex];
  }

  var childContext = useMemo(function () {
    return {
      imageResourcesPath: imageResourcesPath,
      linkService: linkService.current,
      onItemClick: onItemClick,
      pdf: pdf,
      registerPage: registerPage,
      renderMode: renderMode,
      rotate: rotate,
      unregisterPage: unregisterPage
    };
  }, [imageResourcesPath, onItemClick, pdf, renderMode, rotate]);
  var eventProps = useMemo(function () {
    return makeEventProps(otherProps, function () {
      return pdf;
    });
  }, [otherProps, pdf]);

  function renderChildren() {
    return _jsx(DocumentContext.Provider, {
      value: childContext,
      children: children
    });
  }

  function renderContent() {
    if (!file) {
      return _jsx(Message, {
        type: "no-data",
        children: typeof noData === 'function' ? noData() : noData
      });
    }

    if (pdf === undefined || pdf === null) {
      return _jsx(Message, {
        type: "loading",
        children: typeof loading === 'function' ? loading() : loading
      });
    }

    if (pdf === false) {
      return _jsx(Message, {
        type: "error",
        children: typeof error === 'function' ? error() : error
      });
    }

    return renderChildren();
  }

  return _jsx("div", Object.assign({
    className: clsx('react-pdf__Document', className),
    // Assertion is needed for React 18 compatibility
    ref: inputRef,
    style: _defineProperty({}, '--scale-factor', '1')
  }, eventProps, {
    children: renderContent()
  }));
});
export default Document;